import { CampaignDetailModelState } from '@urbanx/agx.campaigns.client';
import { AgxButton, AgxSpacer } from '@urbanx/agx.ui-components2';
import { useFeatureToggles } from 'hooks/useFeatureToggles';

interface ContractFormButtonsProps {
  beginSubmission: () => Promise<void>;
  beginContract: () => Promise<void>;
  beginContractExchange: () => Promise<void>;
  campaignState: CampaignDetailModelState;
  areVendorsValid: boolean;
  disableButtons: boolean;
  isArchived: boolean;
  blankContractIsLive: boolean;
}

const ContractFormButtons = ({
  beginSubmission,
  beginContract,
  beginContractExchange,
  campaignState,
  areVendorsValid,
  disableButtons,
  isArchived,
  blankContractIsLive,
}: ContractFormButtonsProps) => {
  const { enableNswContractExchange } = useFeatureToggles(campaignState);

  switch (campaignState) {
    case CampaignDetailModelState.NSW:
      return (
        <AgxSpacer direction="vertical" gap="xs" contentAlignment="center" fill>
          <AgxButton
            id="agx-begin-contract"
            dataTestId="agx-begin-contract"
            variant="primary"
            size="large"
            stretch
            text={enableNswContractExchange ? 'Sales Advice' : 'New Contract'}
            onClick={beginContract}
            disabled={!areVendorsValid || disableButtons || isArchived}
          />
          {enableNswContractExchange && (
            <AgxButton
              id="agx-contract-exchange"
              variant="hollow"
              size="large"
              stretch
              text="Contract Exchange"
              onClick={beginContractExchange}
              disabled={!blankContractIsLive || !areVendorsValid || disableButtons || isArchived}
            />
          )}
          <AgxButton
            id="agx-submit-contract"
            dataTestId="agx-submit-contract"
            variant="hollow"
            size="large"
            stretch
            text="Submit Contract"
            onClick={beginSubmission}
            disabled={!areVendorsValid || disableButtons || isArchived}
          />
        </AgxSpacer>
      );
    case CampaignDetailModelState.QLD:
    default:
      return (
        <AgxSpacer direction="vertical" gap="xs" contentAlignment="center" fill>
          <AgxButton
            id="agx-submit-contract"
            dataTestId="agx-submit-contract"
            variant="hollow"
            size="large"
            stretch
            text="Submit Contract"
            onClick={beginSubmission}
            disabled={disableButtons || isArchived}
          />
          <AgxButton
            id="agx-begin-contract"
            dataTestId="agx-begin-contract"
            variant="primary"
            size="large"
            stretch
            text="New Contract"
            onClick={beginContract}
            disabled={!blankContractIsLive || disableButtons || isArchived}
          />
        </AgxSpacer>
      );
  }
};

export default ContractFormButtons;
